module.exports = __webpack_public_path__ + "img/icon-header-logout.e420b4f4.svg";